import React from 'react';
import ArchitectureHeader from '../components/architecture/ArchitectureHeader';
import ArchitectureAssetPanel from '../components/architecture/ArchitectureAssetPanel';
import ArchitectureViewport from '../components/architecture/ArchitectureViewport';
import { useArchitectureStore } from '../store/useArchitectureStore';

import DashboardLayout from './DashboardLayout';

import ArchitectureBottomBar from '../components/architecture/ArchitectureBottomBar';
import RegionalIdentityBar from '../components/architecture/RegionalIdentityBar';
import RecentGenerations from '../components/architecture/RecentGenerations';

const ArchitectureLayout: React.FC = () => {
    const { isControlPanelOpen, isRightPanelOpen } = useArchitectureStore();

    return (
        <DashboardLayout>
            <div className="flex h-full w-full bg-stone-950 text-zinc-100 overflow-hidden font-sans">
                {/* Left Control Panel Removed */}

                {/* Center Content */}
                <div className="flex-1 flex flex-col min-w-0 bg-stone-950 relative z-0">
                    <ArchitectureHeader />
                    <div className="flex-1 relative flex flex-col min-h-0">
                        <ArchitectureViewport />

                        {/* Regional & Style Selectors (Bottom Left) */}
                        <RegionalIdentityBar />

                        {/* Recent Generations Gallery (Bottom Center) */}
                        <div className="hidden md:block absolute bottom-6 left-1/2 -translate-x-1/2 z-20 pointer-events-none">
                            <RecentGenerations />
                        </div>

                        {/* Floating Bottom Bar (Generate Button - Right) */}
                        <ArchitectureBottomBar />
                    </div>
                </div>

                {/* Right Asset Panel */}
                <div className={`absolute right-0 top-0 h-full md:relative bg-stone-900 border-l border-stone-800 flex flex-col z-40 transition-all duration-300 ease-in-out ${isRightPanelOpen ? 'w-full sm:w-80 2xl:w-80 xl:w-72 lg:w-60 md:w-52' : 'w-0 border-l-0 overflow-hidden'}`}>
                    <ArchitectureAssetPanel />
                </div>
            </div>
        </DashboardLayout>
    );
};

export default ArchitectureLayout;
